import React, { useEffect, useState } from "react";
import { BASE_URL } from "./../../config/api";

export default function Gallery() {
  const [images, setImages] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);

  useEffect(() => {
    fetchGallery();
  }, []);

  const fetchGallery = async () => {
    try {
      const response = await fetch(`${BASE_URL}/gallery.php`);
      const data = await response.json();

      if (data.status) {
        setImages(data.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // Next Image
  const nextImage = () => {
    setSelectedIndex((prev) => (prev + 1) % images.length);
  };

  // Previous Image
  const prevImage = () => {
    setSelectedIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  // Keyboard Navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (selectedIndex === null) return;

      if (e.key === "ArrowRight") {
        nextImage();
      } else if (e.key === "ArrowLeft") {
        prevImage();
      } else if (e.key === "Escape") {
        setSelectedIndex(null);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedIndex, images]);

  return (
    <div className="container1 p-4">
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill,minmax(350px,1fr))",
          gap: "20px",
        }}
      >
        {images.map((img, index) => (
          <div key={index}>
            <img
              src={img.url}
              alt={img.name}
              onClick={() => setSelectedIndex(index)}
              style={{
                width: "100%",
                height: "350px",
                objectFit: "cover",
                borderRadius: "10px",
                cursor: "pointer",
                transition: "0.3s",
              }}
            />
          </div>
        ))}
      </div>

      {/* Popup */}
      {selectedIndex !== null && (
        <div
          onClick={() => setSelectedIndex(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.9)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              maxWidth: "90%",
              maxHeight: "90%",
            }}
          >
            {/* Close Button */}
            <button
              onClick={() => setSelectedIndex(null)}
              style={{
                position: "absolute",
                top: "-15px",
                right: "-15px",
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                border: "none",
                background: "#aa0f0f",
                fontSize: "20px",
                cursor: "pointer",
                zIndex: 2,
                color: "white",
              }}
            >
              ×
            </button>

            {/* Previous Button */}
            <button
              onClick={prevImage}
              style={{
                position: "absolute",
                left: "-50px",
                top: "50%",
                transform: "translateY(-50%)",
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                border: "none",
                background: "rgba(255,255,255,0.8)",
                fontSize: "20px",
                cursor: "pointer",
              }}
            >
              &#10094;
            </button>

            {/* Image */}
            <img
              src={images[selectedIndex].url}
              alt={images[selectedIndex].name}
              style={{
                maxWidth: "100%",
                maxHeight: "80vh",
                borderRadius: "10px",
                display: "block",
              }}
            />

            {/* Next Button */}
            <button
              onClick={nextImage}
              style={{
                position: "absolute",
                right: "-50px",
                top: "50%",
                transform: "translateY(-50%)",
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                border: "none",
                background: "rgba(255,255,255,0.8)",
                fontSize: "20px",
                cursor: "pointer",
              }}
            >
              &#10095;
            </button>

            {/* Image Counter */}
            <div
              style={{
                color: "#fff",
                textAlign: "center",
                marginTop: "15px",
                fontSize: "18px",
              }}
            >
              {selectedIndex + 1} / {images.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
